























import type { PropType } from "vue"
import type { stadium_business_increase } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"
import moment from "moment"

export default Vue.extend({
  name: "StadiumBusinessForm",
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    form    : { type: Object as PropType<stadium_business_increase> }
  },
  data() {
    return {
      times : [
        {
          start: null as moment.Moment | null,
          end  : null as moment.Moment | null,
          days : [] as string[]
        },
      ],
      days: [
        { label: "周一", value: "1" },
        { label: "周二", value: "2" },
        { label: "周三", value: "3" },
        { label: "周四", value: "4" },
        { label: "周五", value: "5" },
        { label: "周六", value: "6" },
        { label: "周日", value: "0" },
      ]
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        if (this.form.business_time_new && this.form.business_time_new.length > 0) {
          this.times = []
          for (const time of this.form.business_time_new) {
            const temp = time.split(",")
            const t    = temp[0].split("-")
            delete temp[0]
            this.times.push({ start: moment(t[0], "HH:mm"), end: moment(t[1], "HH:mm"), days: temp })
          }
        }
      })
    }
  }
})

